import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterPanel = ({
  searchTerm,
  onSearchChange,
  selectedCategory,
  onCategoryChange,
  selectedDepartment,
  onDepartmentChange,
  dateRange,
  onDateRangeChange,
  pointRange,
  onPointRangeChange,
  departments,
  categories,
  onExport,
  totalCount
}) => {
  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    ...categories?.map(cat => ({ value: cat, label: cat }))
  ];

  const departmentOptions = [
    { value: 'all', label: 'All Departments' },
    ...departments?.map(dept => ({ value: dept, label: dept }))
  ];

  return (
    <div className="bg-card rounded-lg elevation-sm p-4 md:p-6 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        {/* Search */}
        <div className="md:col-span-4">
          <label className="block text-sm font-medium text-foreground mb-2">
            Search
          </label>
          <Input
            type="search"
            placeholder="Search by employee, type, or description..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full"
          />
        </div>

        {/* Category Filter */}
        <div className="md:col-span-3">
          <label className="block text-sm font-medium text-foreground mb-2">
            Category
          </label>
          <Select
            options={categoryOptions}
            value={selectedCategory}
            onChange={onCategoryChange}
            placeholder="Select category"
          />
        </div>

        {/* Department Filter */}
        <div className="md:col-span-3">
          <label className="block text-sm font-medium text-foreground mb-2">
            Department
          </label>
          <Select
            options={departmentOptions}
            value={selectedDepartment}
            onChange={onDepartmentChange}
            placeholder="Select department"
          />
        </div>

        {/* Export Button */}
        <div className="md:col-span-2 flex items-end">
          <Button
            onClick={onExport}
            className="w-full flex items-center justify-center gap-2"
            disabled={totalCount === 0}
          >
            <Icon name="Download" size={18} />
            Export
          </Button>
        </div>
      </div>

      {/* Date Range */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Start Date
          </label>
          <input
            type="date"
            value={dateRange?.start}
            onChange={(e) => onDateRangeChange({ ...dateRange, start: e?.target?.value })}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            End Date
          </label>
          <input
            type="date"
            value={dateRange?.end}
            onChange={(e) => onDateRangeChange({ ...dateRange, end: e?.target?.value })}
            className="w-full px-4 py-2 border border-border rounded-lg bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
      </div>

      {/* Point Range Slider */}
      <div className="mt-4">
        <label className="block text-sm font-medium text-foreground mb-2">
          Point Range: {pointRange?.min} - {pointRange?.max}
        </label>
        <div className="flex items-center gap-4">
          <input
            type="range"
            min="0"
            max="100"
            value={pointRange?.min}
            onChange={(e) => onPointRangeChange({ ...pointRange, min: parseInt(e?.target?.value) })}
            className="flex-1"
          />
          <input
            type="range"
            min="0"
            max="100"
            value={pointRange?.max}
            onChange={(e) => onPointRangeChange({ ...pointRange, max: parseInt(e?.target?.value) })}
            className="flex-1"
          />
        </div>
      </div>

      {/* Legend */}
      <div className="flex flex-wrap items-center gap-4 mt-4 pt-4 border-t border-border">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-blue-500"></div>
          <span className="font-caption text-sm text-muted-foreground">Attendance</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-purple-500"></div>
          <span className="font-caption text-sm text-muted-foreground">Conduct</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-orange-500"></div>
          <span className="font-caption text-sm text-muted-foreground">Performance</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-gray-500"></div>
          <span className="font-caption text-sm text-muted-foreground">Administrative</span>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;